import { useMutation, useQuery } from "@tanstack/react-query";
import { salesforceService } from "../../services/salesforce";
import {
  CreateReportBodyRequest,
  UpdateAlternativeEmailRecordParams,
} from "../../types/services/salesforce";


export const salesforceKeys = {
  all: ["salesforce"] as const,
  reports: () => [...salesforceKeys.all, "reports"] as const,
  report: (id: string) => [...salesforceKeys.reports(), id] as const,
} as const;


export const useCreateSalesforceRecord = () => {
  return useMutation({
    mutationFn: (data: CreateReportBodyRequest) =>
      salesforceService.createSalesForceRecord(data),
    onSuccess: (data) => {
      console.log("✅ Salesforce record created successfully:", data);
    },
    onError: (error) => {
      console.error("❌ Error creating Salesforce record:", error);
    },
  });
};


export const useUpdateAlternativeEmailRecord = () => {
  return useMutation({
    mutationFn: (data: UpdateAlternativeEmailRecordParams) =>
      salesforceService.updateSalesForceAlternativeEmailRecord(data),
    onSuccess: (data) => {
      console.log("✅ Alternative email record updated successfully:", data);
    },
    onError: (error) => {
      console.error("❌ Error updating alternative email record:", error);
    },
  });
};


export const useSendPDF = () => {
  return useMutation({
    mutationFn: (data: { pdfBase64: string; reportId: string }) =>
      salesforceService.sendPDF(data),
    onSuccess: (data) => {
      console.log("✅ PDF sent successfully:", data);
    },
    onError: (error) => {
      console.error("❌ Error sending PDF:", error);
    },
  });
};


export const useGetReport = (reportId: string, enabled = true) => {
  return useQuery({
    queryKey: salesforceKeys.report(reportId),
    queryFn: () => {
      
      throw new Error("Get report endpoint not implemented");
    },
    enabled: enabled && !!reportId,
  });
};
